let currentUrlArr = location.pathname.split("/");
let actor = currentUrlArr[1];
// タイムチャージ型 時間整形
$(() => {
    if (document.getElementById('time-table') != null) {
        let now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth()+1;
        let day = now.getDate();

        $(document).on("click", '.js-add-time-row', e => {
            e.preventDefault();
            let targetRow = $(e.currentTarget).parents('tr');
            $($(targetRow).find('td:nth-child(1)'))
                .css({'border-bottom': '1px solid #dee2e6'});
            let row = targetRow.clone();
            let id = $('#time-table').data('last_edited_id') + 1;

            //idを設定
            row.attr('data-id', id);
            $(row.find('input[name^=start_time]')).attr('name', 'start_time[n' + id + ']');
            $(row.find('input[name^=end_time]')).attr('name', 'end_time[n' + id + ']');
            $(row.find('input[name^=breaking_duration]')).attr('name', 'breaking_duration[n' + id + ']');
            $(row.find('input[name^=contents]')).attr('name', 'contents[n' + id + ']');
            $(row.find('input[name^=target_date]')).attr('name', 'target_date[n' + id + ']');
            $($(row).find('input')).removeClass('is-invalid');

            // class 置換
            $(row).find('.time-row-btn')
                .addClass('js-sub-time-row')
                .removeClass('js-add-time-row');

            // 画像置換
            $(row).find('.time-row-btn-icon')
                .attr('src', '/images/report-time-sub-row.png');

            // 日付空欄
            $($(row).find('td:nth-child(1)'))
                .css({
                    'visibility':'hidden',
                    'border': 'none'
                })
                .text('');
            $(row).css({'border-left': '1px solid #ffffff'});

            // valueの初期化
            row.find('input').each(function(){
                if ($(this).attr('type') !== 'hidden') {
                    $(this).val('');
                }
            });
            // 勤務時間消去
            $(row.find('.js-working_duration span')).text('');
            // 行追加
            let day_rows = targetRow.attr('class').split(' ');
            $('.' + day_rows.splice(day_rows.indexOf('day-', 1))).last().after(row);

            // table内最大IDの更新
            $('#time-table').data('last_edited_id', id);
            time_focus();
            time_focusout();

            replace_row_btn(targetRow);

            let delete_rows = $('input[name=delete_rows]').val();
            let dell = delete_rows.split(',');
            let index = dell.indexOf(id);
            if (index === -1) {
                dell.splice(index, 1);
                $('input[name=delete_rows]').val(dell.join(','));
            }
            sub_time_row();
        });

        // 初期表示で日毎5行あればボタンを隠す
        $('#time-table tr').each( function (index, tr) {
            replace_row_btn(tr);
        });

        function replace_row_btn(tr) {
            let $day_tr = $('#time-table tr.day-' + $(tr).data('base_day'));
            if ($day_tr.length >= 5) {
                $day_tr.first().find('.js-add-time-row')
                    .addClass('time-row-btn-hide')
                    .removeClass('js-add-time-row');
            }
        }

        function sub_time_row () {
            $(document).on("click", '.js-sub-time-row', e => {
                let tr = $(e.currentTarget).parents('tr');
                let id = tr.data('id');
                let last_id = $('#time-table').data('last_edited_id');
                if (id >= last_id) {
                    $('#time-table').data('last_edited_id', id - 1);
                }
                let day = tr.data('base_day');
                $('#time-table tr.day-' + day + ' div.time-row-btn-hide')
                    .removeClass('time-row-btn-hide')
                    .addClass('js-add-time-row');
                tr.remove();
                let trs = $('#time-table tr.day-' + day);
                let tr_cnt = trs.length;
                let delete_rows = $('input[name=delete_rows]').val();
                let dell = delete_rows.split(',');
                dell[dell.length] = id;
                $('input[name=delete_rows]').val(dell.join(','));
            });
        }
        sub_time_row();

        function time_focus(){
            $('.time').focus(function(){
                let str_time = $(this).val().replace(/:/g, '');
                $(this).val(str_time);
            });
        }
        time_focus();

        function time_focusout(){
            $('.time').focusout(function(){
                let start_time = $(this).parent().parent().find('.js-start_time > input').val();
                let end_time = $(this).parent().parent().find('.js-end_time > input').val();
                let breaking_duration = $(this).parent().parent().find('.js-breaking_duration > input').val();
                let comparison_flag = false;
                // 最大値固定
                let str_time = $(this).val();
                str_time = str_time.replace(/[^0-9]/g, '');
                // 3桁の場合はゼロ埋め
                if (str_time.length == 3) {
                    str_time  = '0' + str_time;
                }
                if (end_time.length == 3) {
                    end_time  = '0' + end_time;
                }
                // 一旦ここでフォーマットを整形
                // 時 ゼロ埋め
                let str_time_hour = str_time.slice(0, 2);
                let hour = ('00' + str_time_hour).slice(-2);
                // 分 ゼロ埋め
                let str_time_minutes = str_time.slice(2, 4);
                if (parseInt(str_time_minutes) > 59) {
                    str_time_minutes = '';
                }
                let minutes = ('00' + str_time_minutes).slice(-2);

                str_time = hour + minutes;
                if ($(this).hasClass('start')){
                    if (parseInt(str_time) > 2359) {
                        str_time = '2359';
                        start_time = str_time.slice(0, 2)+':'+str_time.slice(2, 4);
                    }
                    // 退勤時間 ＜ 出勤時間 であれば退勤時間を出勤時間に揃える
                    let comparison = end_time.replace(':', '');
                    if (comparison && comparison < str_time) {
                        str_time = comparison;
                        comparison_flag = true;
                    }
                } else {
                    if (parseInt(str_time) > 4759) {
                        str_time = '4759';
                        if ($(this).hasClass('end')) {
                            end_time = str_time.slice(0, 2)+':'+str_time.slice(2, 4);
                        } else {
                            breaking_duration = str_time.slice(0, 2)+':'+str_time.slice(2, 4);
                        }
                    }
                    // 退勤時間 ＜ 出勤時間 であれば退勤時間を出勤時間に揃える
                    let comparison = start_time.replace(':', '');
                    if ($(this).hasClass('end') && comparison && str_time < comparison) {
                        str_time = comparison;
                        comparison_flag = true;
                    }
                }
                // ↑で上限の変換が入るので整形しなおす
                str_time_hour = str_time.slice(0, 2);
                hour = ('00' + str_time_hour).slice(-2);
                str_time_minutes = str_time.slice(2, 4);
                if (parseInt(str_time_minutes) > 59) {
                    str_time_minutes = '';
                }
                minutes = ('00' + str_time_minutes).slice(-2);
                // 入力値をセット 入力された値がnullでなければセットする
                if ($(this).val()) {
                    $(this).val(hour + ':' + minutes);
                    // 退勤時間 ＜ 出勤時間 であれば退勤時間を入れ直す
                    if (comparison_flag) {
                        end_time = hour + ':' + minutes;
                    }
                }

                // 稼働時間を計算
                let start_time_date = get_time(start_time);
                let end_time_date = get_time(end_time);
                let breaking_duration_date = get_time(breaking_duration);

                // 出勤と退勤の差分
                let diff = end_time_date.getTime() - start_time_date.getTime();
                let diff_hour = diff / (1000 * 60 * 60);
                let diff_minute = (diff_hour - Math.floor(diff_hour)) * 60;

                // 出勤と退勤の差分と休憩時間の差分
                let start_and_end_time_date = get_time(('00' + Math.floor(diff_hour)).slice(-2)+':'+('00' + Math.round(diff_minute)).slice(-2));
                let real_diff = start_and_end_time_date.getTime() - breaking_duration_date.getTime();
                let real_diff_hour = real_diff / (1000 * 60 * 60);
                let real_diff_minute = (real_diff_hour - Math.floor(real_diff_hour)) * 60;
                let working_duration = null;
                if (real_diff_hour > 0) {
                    working_duration = ('00' + Math.floor(real_diff_hour)).slice(-2)+':'+('00' + Math.round(real_diff_minute)).slice(-2);
                } else if(start_time_date > 0 || end_time_date > 0) {
                    working_duration = '00:00';
                }
                // 稼働時間をセット
                if (end_time) {
                    $(this).parent().parent().find('.js-working_duration > span').text(working_duration);
                } else {
                    $(this).parent().parent().find('.js-working_duration > span').text('');
                }

                // 稼働期間を取得
                let working_durations = (function (){
                    let array = [];
                    $('.js-working_duration').each(function() {
                        let working_duration = $(this).find('span').text();
                        if (working_duration) {
                            array.push(working_duration);
                        }
                    })
                    return array;
                }());

                // PHP側の合計稼働時間ロジックを通して計算する
                $.ajax({
                    url: '/api/ajaxTotalWorkingDuration',
                    type: 'get',
                    dataType : 'json',
                    data: {
                        actor: actor,
                        original_condition_id: currentUrlArr[3],
                        working_durations: working_durations,
                        term: currentUrlArr[4]
                    }
                }).done(function(data, textStatus, jqXHR) {
                    $('.total-time').text(data + 'h');
                }).fail(function(jqXHR, textStatus, errorThrown ) {
                }).always(function(){
                });
            });
        }
        time_focusout();

        // エラーの日付は赤枠表示
        let modal = $('.modal#error_day_modal');
        if (modal) {
            modal.find('button[data-dismiss="modal"]').on('click', () => {
                $('.error-day').each((_, tr) => {
                    $(tr).attr('class', 'table-danger-bg');
                });
            });
        }

        // 日時フォーマットに変換
        function get_time(time)
        {
            let replace_time = time.replace(/:/g, '');
            if (replace_time == '') {
                replace_time = '0000';
            }
            let time_hour = replace_time.slice(0, 2);
            let time_minutes = replace_time.slice(2, 4);
            let time_date = new Date(year, month, day, time_hour, time_minutes);

            return time_date;
        }
    }
});
